/**
 * ? @description : Audio History Component
 */

// Dependencies
import React from "react";
import { AgGridReact } from "ag-grid-react";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

function AudioHistoryTable(props) {
  // * Column Definition for the Table Data
  const columnHeader = [
    {
      headerName: "Audio File Name",
      field: "audio_file_name",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Audio Status",
      field: "audio_status",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Reason",
      field: "audio_reason",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Audio Audit By",
      field: "audio_audit_by",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Audio Uploaded At",
      field: "audio_uploaded_at",
      filter: true,
      sortable: true,
      cellRenderer: (params) => <div>{DateFormatting(params)}</div>,
      sort: 'desc'
    },
  ];

  function DateFormatting(params) {
    let theDate = new Date(Date.parse(params.value)).toLocaleString("en-IN", {
      timeZone: "Asia/Calcutta",
    });
    return theDate;
  }

  return (
    <div
      className="ag-theme-alpine my-2"
      style={{ width: "100%", height: "225px" }}
    >
      <AgGridReact
        defaultColDef={{ flex: 1 }}
        rowData={props.data}
        columnDefs={columnHeader}
        pagination={true}
        paginationPageSize={5}
        paginationAutoPageSize={true}
      />
    </div>
  );
}

export default AudioHistoryTable;
